import CustomerIcon from "@mui/icons-material/Business";
import { useSelector } from "react-redux";
import { selectors as customerSelectors } from "../../redux/customers";
import BaseTag from "./BaseTag";

const CustomerTag = (props) => {
  const entity = useSelector((state) =>
    customerSelectors.selectById(state, props.value),
  );
  const label = props.value === "__is_null" ? "No-Customer" : entity?.name;
  return <BaseTag icon={<CustomerIcon />} label={label} />;
};

export default CustomerTag;
